__turbopack_context__.v({
  "className": "sohne_29b96b3-module__HY04Qa__className",
  "variable": "sohne_29b96b3-module__HY04Qa__variable",
});
